
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_fvjdu_18x54_94",
  "button": "awsui_button_fvjdu_18x54_112",
  "dots": "awsui_dots_fvjdu_18x54_113",
  "button-disabled": "awsui_button-disabled_fvjdu_18x54_135",
  "arrow": "awsui_arrow_fvjdu_18x54_140",
  "page-number": "awsui_page-number_fvjdu_18x54_150",
  "button-current": "awsui_button-current_fvjdu_18x54_156",
  "page-item": "awsui_page-item_fvjdu_18x54_173",
  "root-disabled": "awsui_root-disabled_fvjdu_18x54_189"
};
  